import {t} from './localeText';
import {useEffect, useRef, useState} from 'react';
import s from './capability.module.less';

export default function CapabilityModel({model, lang = 'zh'}) {
    const [selected, setSelected] = useState(0);
    const tabRefs = useRef([]);
    const sectionRef = useRef(null);
    useEffect(() => {
        if (window.location.hash !== '#capability-model') return;
        const frame = requestAnimationFrame(() => sectionRef.current?.scrollIntoView({block: 'start'}));
        return () => cancelAnimationFrame(frame);
    }, []);
    const onTabKeyDown = (event, index) => {
        const count = model.dimensions.length;
        const next = {ArrowRight: (index + 1) % count, ArrowDown: (index + 1) % count, ArrowLeft: (index - 1 + count) % count, ArrowUp: (index - 1 + count) % count, Home: 0, End: count - 1}[event.key];
        if (next === undefined) return;
        event.preventDefault();
        setSelected(next);
        tabRefs.current[next]?.focus();
    };
    const revealEvidence = (event) => {
        const target = document.querySelector(event.currentTarget.getAttribute('href'));
        if (!target) return;
        // Open the overview before native anchor navigation measures its position.
        const overview = target.closest('details');
        if (overview) overview.open = true;
    };

    return <section ref={sectionRef} className={s.model} id='capability-model' aria-labelledby='capability-heading'>
        <header className={s.header}>
            <h2 id='capability-heading'>{model.headline}</h2>
            <p className={s.intro}>{model.intro}</p>
        </header>
        <div className={s.workspace}>
            <div className={s.navigation} role='tablist' aria-label={t(lang, '能力维度')}>
                {model.groups.map((group) => <div className={s.group} key={group.label} role='presentation'>
                    <p className={s.groupLabel}>{group.label}</p>
                    <div className={s.groupTabs} role='presentation'>
                        {group.dimensions.map((id) => {
                            const index = model.dimensions.findIndex((dimension) => dimension.id === id);
                            const dimension = model.dimensions[index];
                            return <button
                                key={id}
                                ref={(node) => { tabRefs.current[index] = node; }}
                                type='button'
                                role='tab'
                                id={`capability-tab-${id}`}
                                className={s.tab}
                                aria-selected={selected === index}
                                aria-controls={`capability-panel-${id}`}
                                tabIndex={selected === index ? 0 : -1}
                                onClick={() => setSelected(index)}
                                onKeyDown={(event) => onTabKeyDown(event, index)}
                            >
                                <span className={s.tabNumber} aria-hidden='true'>{String(index + 1).padStart(2, '0')}</span>
                                <strong>{dimension.short}</strong>
                                <span className={s.tabArrow} aria-hidden='true'>↗</span>
                            </button>;
                        })}
                    </div>
                </div>)}
            </div>
            {model.dimensions.map((dimension, index) => <div
                key={dimension.id}
                className={s.detail}
                role='tabpanel'
                id={`capability-panel-${dimension.id}`}
                aria-labelledby={`capability-tab-${dimension.id}`}
                tabIndex={0}
                hidden={selected !== index}
            >
                <div className={s.detailContent}>
                    <div className={s.detailHeading}><p>{dimension.name}</p><span aria-hidden='true'>{String(index + 1).padStart(2, '0')}</span></div>
                    <h3>{dimension.thesis}</h3>
                    <p className={s.description}>{dimension.description}</p>
                    <dl className={s.responsibilities}>
                        <div><dt>{dimension.decisionLabel || t(lang, '技术深度')}</dt><dd>{dimension.decision}</dd></div>
                        <div><dt>{t(lang, '主导职责')}</dt><dd>{dimension.mechanism}</dd></div>
                    </dl>
                    <div className={s.accountability}><span>{t(lang, '代表实践')}</span><p>{dimension.practice}</p></div>
                    <div className={s.links}><span>{t(lang, '相关经历')}</span>{dimension.links.map((item) => <a key={item.href} href={item.href} onClick={revealEvidence}>{item.label}<span aria-hidden='true'> ↗</span></a>)}</div>
                </div>
            </div>)}
        </div>
    </section>;
}
